<template>
  <el-menu
    :default-active="activeIndex"
    :router="true"
    mode="horizontal"
  >
    <el-menu-item
      index="/"
      route="/"
    >
      <i class="el-icon-s-home" />
      <span>Főoldal</span>
    </el-menu-item>
    <el-submenu index="/data"
      v-can="['administration.car.view', 'data.productcategory.view', 'data.productorder.view', 'data.product.view', 'partner.view', 'shopcategory.view', 'data.owncompany.view', 'customergroup.view', 'data.manufacturer.view', 'data.servicecategory.view', 'data.service.view', 'shopcategory.view', 'shop.view', 'shopchain.view', 'storage.view', 'customerpricelist.view']">
      <template slot="title">
        <i class="el-icon-s-grid" />
        <span>Törzsadatok</span>
      </template>
      <el-menu-item
        v-can="'data.owncompany.view'"
        index="/data/own-companies"
        route="/data/own-companies"
      >
        Saját cégek
      </el-menu-item>
      <el-menu-item
        v-can="'storage.view'"
        index="/data/storages"
        route="/data/storages"
      >
        Raktárak
      </el-menu-item>
      <el-menu-item
        index="/data/partners"
        route="/data/partners"
        v-can="'partner.view'"
      >
        Partnerek
      </el-menu-item>
      <el-menu-item
        index="/data/customer-groups"
        route="/data/customer-groups"
        v-can="'customergroup.view'"
      >
        Vevőcsoportok
      </el-menu-item>
      <template v-if="$config('SHOW_MENU_SHOPS')">
        <el-menu-item index="/data/shops/shops"
          route="/data/shops/shops"
          v-can="['shopcategory.view', 'shop.view', 'shopchain.view']">
          Üzletek
        </el-menu-item>
      </template>
      <template v-if="$config('SHOW_MENU_CARS')">
      <el-menu-item index="/data/cars"
        route="/data/cars"
        v-can="'administration.car.view'">
        Gépkocsik
      </el-menu-item>
      </template>
      <el-menu-item
        v-can="['data.productcategory.view', 'data.product.view', 'data.productorder.view']"
        index="/data/products"
        route="/data/products"
      >
        Termékek
      </el-menu-item>
      <el-menu-item
        v-can="['data.servicecategory.view', 'data.service.view']"
        index="/data/services/services"
        route="/data/services/services"
      >
        Szolgáltatások
      </el-menu-item>
      <el-menu-item
        v-can="'customerpricelist.view'"
        index="/data/customer-price-lists"
        route="/data/customer-price-lists"
      >
        Központi Árlisták
      </el-menu-item>
    </el-submenu>
    <el-submenu
      v-can="['supplierorder.view', 'inwardhandling.view', 'supplierreturnorder.view', 'representativeorder.view', 'packing.view', 'declutter.view', 'stocktaking.view', 'stocktakingreport.view', 'stocktransformation.view']"
      index="/processes"
    >
      <template slot="title">
        <i class="el-icon-box" />
        <span>Raktár & Beszerzés</span>
      </template>
      <el-menu-item
        v-can="['supplierorder.view']"
        index="/processes/supplier-orders"
        route="/processes/supplier-orders"
      >
        Beszállítói megrendelések
      </el-menu-item>
      <el-menu-item
        v-can="['inwardhandling.view']"
        index="/processes/inward-handlings"
        route="/processes/inward-handlings"
      >
        Bevételezések
      </el-menu-item>
      <el-menu-item
        v-can="['supplierreturnorder.view']"
        index="/processes/supplier-return-orders"
        route="/processes/supplier-return-orders"
      >
        Beszállítói visszáruk
      </el-menu-item>
      <template v-if="$config('SHOW_MENU_PACKINGS')">
      <el-menu-item
        v-can="['packing.view']"
        index="/processes/packings"
        route="/processes/packings"
      >
        Csomagolás
      </el-menu-item>
      </template>
      <template v-if="$config('SHOW_MENU_DECLUTTERS')">
      <el-menu-item
        v-can="['declutter.view']"
        index="/processes/declutters"
        route="/processes/declutters"
      >
        Selejtezés
      </el-menu-item>
      </template>
      <el-menu-item
        v-can="['stocktaking.view']"
        index="/processes/stock-takings/stock-takings"
        route="/processes/stock-takings/stock-takings"
      >
        Leltár
      </el-menu-item>
      <template v-if="$config('SHOW_MENU_STOCK_TRANSFORMATIONS')">
      <el-menu-item
        v-can="['stocktransformation.view']"
        index="/processes/stock-transformations"
        route="/processes/stock-transformations"
      >
        Készlet transzformáció
      </el-menu-item>
      </template>
      <template v-if="$config('SHOW_MENU_STOCK_MOVEMENTS')">
        <el-menu-item
          v-can="['stockmovement.view']"
          index="/processes/stock-movements"
          route="/processes/stock-movements"
        >
          Készletmozgatás
        </el-menu-item>
      </template>
    </el-submenu>
    <el-submenu index="/sales"
      v-can="['invoicebook.view', 'customerorder.view', 'stowage.view', 'customersale.view', 'representativeorder.view', 'invoice.view', 'proformcustomerorder.view', 'representativedeliveries.view']">
      <template slot="title">
        <i class="el-icon-money" />
        <span>Eladás</span>
      </template>
      <el-menu-item
        v-can="'proformcustomerorder.view'"
        index="/sales/proform-customer-orders"
        route="/sales/proform-customer-orders"
      >
        Proforma megrendelések
      </el-menu-item>
      <el-menu-item
        v-can="'customerorder.view'"
        index="/sales/customer-orders"
        route="/sales/customer-orders"
      >
        Vevői megrendelések
      </el-menu-item>
      <template v-if="$config('SHOW_MENU_REPRESENTATIVE_ORDERS')">
      <el-menu-item
        v-can="['representativeorder.view']"
        index="/sales/representative-orders"
        route="/sales/representative-orders"
      >
        Raktárközi megrendelések
      </el-menu-item>
      </template>
      <el-menu-item
        v-can="'stowage.view'"
        index="/sales/stowages"
        route="/sales/stowages"
      >
        Rakodási listák
      </el-menu-item>
      <el-menu-item
        v-can="'customersale.view'"
        index="/sales/customer-sales"
        route="/sales/customer-sales"
      >
        Vevői eladások
      </el-menu-item>
      <template v-if="$config('SHOW_MENU_REPRESENTATIVE_DELIVERIES')">
      <el-menu-item
        v-can="'representativedeliveries.view'"
        index="/sales/representative-deliveries"
        route="/sales/representative-deliveries"
      >
        Raktárközi szállítólevelek
      </el-menu-item>
      </template>
      <el-menu-item
        v-can="'customerreturnorder.view'"
        index="/sales/customer-return-orders"
        route="/sales/customer-return-orders"
      >
        Vevői visszáru
      </el-menu-item>

      <template v-if="$config('SHOW_MENU_INVOICES')">
      <el-menu-item
        v-can="'invoice.view'"
        index="/sales/invoices"
        route="/sales/invoices"
      >
        Számlák
      </el-menu-item>
      </template>
      <template v-if="$config('SHOW_MENU_INVOICE_BOOKS')">
      <el-menu-item
        v-can="'invoicebook.view'"
        index="/sales/invoice-books"
        route="/sales/invoice-books"
      >
        Számlatömbök
      </el-menu-item>
      </template>
    </el-submenu>
    <template v-if="$config('SHOW_MENU_REPRESENTATIVE_PROCESSES')">
    <el-submenu
      v-can="['representativepayment.view', 'representativedrop.view', 'process.task.view', 'tourcalendar.view', 'representativeplacement.view', 'representativeform.view', 'representativeprice.view', 'representativesale.view', 'receiptreceives.view', 'receipttransfer.view', 'representativereplacement.view']"
      index="/representative-processes"
    >
      <template slot="title">
        <i class="el-icon-truck" />
        <span>Képviselői folyamatok</span>
      </template>
      <el-submenu
        v-can="['representativeprice.view']"
        index="representative-price-lists"
      >
        <template slot="title">Árlisták</template>
        <el-menu-item
          index="/representative-processes/representative-prices/default"
          route="/representative-processes/representative-prices/default"
        >
          Alapértelmezett árak
        </el-menu-item>
        <el-menu-item
          index="/representative-processes/representative-prices/custom"
          route="/representative-processes/representative-prices/custom"
        >
          Egyedi árak
        </el-menu-item>
      </el-submenu>
      <el-menu-item
        v-can="['representativedrop.view']"
        index="/representative-processes/representative-drops"
        route="/representative-processes/representative-drops"
      >
        Termék leadások
      </el-menu-item>
      <el-submenu
        v-can="['representativetransfer.view']"
        index="representative-transfers"
      >
        <template slot="title">Készletáthelyezések</template>
        <el-menu-item
          index="/representative-processes/representative-transfer-requests"
          route="/representative-processes/representative-transfer-requests"
        >
          Kérelmek
        </el-menu-item>
        <el-menu-item
          index="/representative-processes/representative-transfers"
          route="/representative-processes/representative-transfers"
        >
          Áthelyezések
        </el-menu-item>
      </el-submenu>
      <el-menu-item
        v-can="['representativereplacement.view']"
        index="/representative-processes/representative-replacements"
        route="/representative-processes/representative-replacements"
      >
        Képviselő áthelyezések
      </el-menu-item>
      <el-menu-item
        v-can="['receipttransfer.view']"
        index="/representative-processes/receipt-transfers"
        route="/representative-processes/receipt-transfers"
      >
        Bizonylat áthelyezések
      </el-menu-item>
      <el-menu-item
        v-can="['tourcalendar.view']"
        index="/representative-processes/tour-calendars"
        route="/representative-processes/tour-calendars"
      >
        Túranapok
      </el-menu-item>
      <el-menu-item
        v-can="['process.task.view']"
        index="/representative-processes/tasks"
        route="/representative-processes/tasks"
      >
        Időszaki munkák
      </el-menu-item>
      <el-menu-item
        v-can="['representativeplacement.view']"
        index="/representative-processes/representative-placements"
        route="/representative-processes/representative-placements"
      >
        Kihelyezések
      </el-menu-item>
      <el-menu-item
        v-can="['representativesale.view']"
        index="/representative-processes/representative-saless"
        route="/representative-processes/representative-sales"
      >
        Eladások
      </el-menu-item>
      <el-menu-item
        v-can="['representativepayment.view']"
        index="/representative-processes/payments"
        route="/representative-processes/payments"
      >
        Befizetések
      </el-menu-item>
      <el-menu-item
        v-can="['representativeform.view']"
        index="/representative-processes/representative-forms"
        route="/representative-processes/representative-forms"
      >
        Nyomtatványok
      </el-menu-item>
      <el-menu-item
        v-can="['receiptreceives.view']"
        index="/representative-processes/receipt-receives/invoice"
        route="/representative-processes/receipt-receives/invoice"
      >
        Bizonylat beérkeztetés
      </el-menu-item>
    </el-submenu>
    </template>
    <el-submenu
      v-can="['user.view', 'role.view', 'usercategory.view', 'settings.country.view', 'settings.county.view', 'settings.vat.view', 'settings.glanumber.view', 'settings.currency.view', 'settings.customstariffnumber.view', 'receiptsetting.view', 'ntax.view', 'todo.view', 'documenttype.view', 'docketbook.view', 'docket.view']"
      index="/users"
    >
      <template slot="title">
        <i class="el-icon-document-copy" />
        <span>Adminisztráció</span>
      </template>
      <el-menu-item
        v-can="['user.view', 'role.view', 'usercategory.view']"
        index="/users"
        route="/users"
      >
        Felhasználókezelő
      </el-menu-item>
      <el-menu-item
        v-can="['settings.country.view', 'settings.county.view', 'settings.vat.view', 'settings.glanumber.view', 'settings.currency.view', 'settings.customstariffnumber.view', 'appversion.view']"
        index="/lists"
        route="/lists"
      >
        Listák
      </el-menu-item>
      <el-menu-item
        v-can="['receiptsetting.view']"
        index="/receipts"
        route="/receipts"
      >
        Bizonylat előtagok
      </el-menu-item>
      <el-menu-item
        v-can="['todo.view']"
        index="/todos"
        route="/todos"
      >
        Todo kezelő
      </el-menu-item>
      <template v-if="$config('SHOW_MENU_INVOICE_BOOKS')">
      <el-menu-item
        v-can="['ntax.view']"
        index="/ntax-invoices"
        route="/ntax-invoices?ntax_exported=0"
      >
        NTAX könyvelés
      </el-menu-item>
      </template>
      <template v-if="$config('SHOW_MENU_DOCKETS')">
      <el-menu-item
        v-can="['documenttype.view', 'docketbook.view', 'docket.view']"
        index="/docket/dockets"
        route="/docket/dockets"
      >
        Iktató
      </el-menu-item>
      </template>
      <template v-if="$config('SHOW_MENU_APP_VERSIONS')">
      <el-menu-item
        v-can="['appversion.view']"
        index="/app-versions"
        route="/app-versions"
      >
        App verziók
      </el-menu-item>
      </template>
      <template v-if="$config('SHOW_MENU_DOC_VERSIONS')">
      <el-menu-item
        v-can="['docversion.view']"
        index="/doc-versions"
        route="/doc-versions"
      >
        Dokumentáció verziók
      </el-menu-item>
      </template>
      <!-- add config and add to template: v-if="$config('SHOW_MENU_IMPORTS')"-->
      <!-- add to el-menu-item: v-can="['imports.view']"-->
      <template>
        <el-menu-item
          index="/imports"
          route="/imports"
        >
          Importok
        </el-menu-item>
      </template>
    </el-submenu>
    <el-submenu
      v-can="['storagestockreport.view', 'stockdifference.view', 'producthistory.view', 'stockvalue.view', 'productconsumption.view', 'palletreport.view', 'commissionreport.view', 'representativereport.view',  'outstandingreport.view', 'paretoreport.view', 'representativepaymentreport.view', 'pricebreakdown.view', 'worktimereport.view', 'navaudit.view', 'netareport.view', 'vatreport.view', 'pirosmogyorosreport.view']"
      index="/reports"
    >
      <template slot="title">
        <i class="el-icon-pie-chart" />
        <span>Lekérdezések</span>
      </template>
      <el-submenu
        v-can="['storagestockreport.view', 'stockdifference.view', 'producthistory.view', 'stockvalue.view', 'productconsumption.view', 'palletreport.view']"
        index="/reports/stocks"
      >
        <template slot="title">Készlet</template>
        <el-menu-item
          v-can="['storagestockreport.view']"
          index="/reports/storage-stock"
          route="/reports/storage-stock"
        >
          Árukészlet
        </el-menu-item>
        <el-menu-item
          v-can="['stockdifference.view']"
          index="/reports/stock-difference"
          route="/reports/stock-difference"
        >
          Leltáreltérés
        </el-menu-item>
        <el-menu-item
          v-can="['producthistory.view']"
          index="/reports/product-history"
          route="/reports/product-history"
        >
          Terméktörténet
        </el-menu-item>
        <!--        <el-menu-item-->
        <!--          v-can="['stockvalue.view']"-->
        <!--          index="/reports/stock-value"-->
        <!--          route="/reports/stock-value"-->
        <!--        >-->
        <!--          Készletérték2-->
        <el-menu-item
          v-can="['simplestockvalue.view']"
          index="/reports/simple-stock-value"
          route="/reports/simple-stock-value"
        >
          Készletérték
        </el-menu-item>
        <el-menu-item
          v-can="['productconsumption.view']"
          index="/reports/product-consumption"
          route="/reports/product-consumption"
        >
          Termékfogyás
        </el-menu-item>
        <template v-if="$config('SHOW_MENU_PALLET_REPORT')">
        <el-menu-item
          v-can="['palletreport.view']"
          index="/reports/pallet"
          route="/reports/pallet"
        >
          Raklap
        </el-menu-item>
        </template>
      </el-submenu>
      <template v-if="$config('SHOW_MENU_REPRESENTATIVES')">
      <el-submenu
        v-can="['commissionreport.view', 'representativereport.view', 'outstandingreport.view', 'paretoreport.view', 'representativepaymentreport.view', 'pricebreakdown.view', 'worktimereport.view']"
        index="/reports/representatives"
      >
        <template slot="title">Képviselői kimutatások</template>
        <el-menu-item
          v-can="['outstandingreport.view']"
          index="/reports/outstandings"
          route="/reports/outstandings"
        >
          Kintlévőségek
        </el-menu-item>
        <el-menu-item
          v-can="['paretoreport.view']"
          index="/reports/pareto"
          route="/reports/pareto"
        >
          Pareto
        </el-menu-item>
        <el-menu-item
          v-can="['representativepaymentreport.view']"
          index="/reports/representative-payments/sum"
          route="/reports/representative-payments/sum"
        >
          Képviselői befizetések
        </el-menu-item>
        <el-menu-item
          v-can="['pricebreakdown.view']"
          index="/reports/price-breakdown"
          route="/reports/price-breakdown"
        >
          Árbontás
        </el-menu-item>
        <el-menu-item
          v-can="['worktimereport.view']"
          index="/reports/worktime"
          route="/reports/worktime"
        >
          Munkaidő
        </el-menu-item>
        <el-menu-item
          v-can="['commissionreport.view']"
          index="/reports/commission"
          route="/reports/commission"
        >
          Jutalék
        </el-menu-item>
        <el-menu-item
          v-can="['representativereport.view']"
          index="/reports/representatives"
          route="/reports/representatives"
        >
          Területi vezetői kimutatás
        </el-menu-item>
        <el-menu-item
          v-can="['representativetaskreport.view']"
          index="/reports/representative-task"
          route="/reports/representative-task"
        >
          Időszaki munkák
        </el-menu-item>
      </el-submenu>
      </template>
      <template v-if="$config('SHOW_MENU_CENTRAL')">
      <el-submenu
        v-can="['invoiceitemsreport.view', 'inwardhandlingitemsreport.view', 'customersaleandreturnreport.view', 'invoiceitemsbypartnerreport.view', 'pirosmogyorosreport.view']"
        index="/reports/central"
      >
        <template slot="title">Központi kimutatások</template>
        <el-menu-item
          v-can="['invoiceitemsreport.view']"
          index="/reports/invoice-items"
          route="/reports/invoice-items"
        >
          Vevői számla tételek
        </el-menu-item>
        <el-menu-item
          v-can="['inwardhandlingitemsreport.view']"
          index="/reports/inward-handling-items"
          route="/reports/inward-handling-items"
        >
          Beszállítások napokra
        </el-menu-item>
        <el-menu-item
          v-can="['customersaleandreturnreport.view']"
          index="/reports/customer-sale-and-return"
          route="/reports/customer-sale-and-return"
        >
          Vevői eladások és viszáruk
        </el-menu-item>
        <el-menu-item
          v-can="['invoiceitemsbypartnerreport.view']"
          index="/reports/invoice-items-by-partner"
          route="/reports/invoice-items-by-partner"
        >
          Vevői tételes lista
        </el-menu-item>
        <template v-if="$config('PIROS_MOGYOROS_ALLOWED')">
        <el-menu-item
          v-can="['pirosmogyorosreport.view']"
          index="/reports/piros-mogyoros"
          route="/reports/piros-mogyoros"
        >
          Piros Mogyorós kimutatás
        </el-menu-item>
        </template>
      </el-submenu>
      </template>
      <template v-if="$config('SHOW_MENU_TAXING')">
      <el-submenu
        v-can="['netareport.view', 'vatreport.view']"
        index="/reports/accountant"
      >
        <template slot="title">Adózás</template>
        <el-menu-item
          v-can="['vatreport.view']"
          index="/reports/vat/central"
          route="/reports/vat/central"
        >
          Áfa
        </el-menu-item>
        <el-menu-item
          v-can="['netareport.view']"
          index="/reports/neta/central"
          route="/reports/neta/central"
        >
          Neta
        </el-menu-item>
      </el-submenu>
      </template>
      <template v-if="$config('SHOW_MENU_AUDIT')">
      <el-menu-item
        v-can="['navaudit.view']"
        index="/reports/nav-audit"
        route="/reports/nav-audit"
      >
        NAV adatszolgáltatás
      </el-menu-item>
      </template>
    </el-submenu>
    <el-submenu
      index="4"
      style="float: right;"
    >
      <template slot="title">
        <el-avatar
          v-if="profileUrl"
          :src="profileUrl"
          style="margin-right: 10px;width: 30px;height: 30px;"
        />
        <span>{{ user.last_name }} {{ user.first_name }}</span>
      </template>
      <el-menu-item
        index="/my-profile"
        route="/my-profile"
      >
        Fiókom
      </el-menu-item>
      <el-menu-item
        @click="logout"
      >
        Kijelentkezés
      </el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
  import gravatar from 'gravatar';

  export default {
    computed: {
      user() {
        return this.$store.getters['auth/user'];
      },
      activeIndex() {
        return this.$route.path;
      },
      profileUrl() {
        if (this.user && this.user.email) {
          return gravatar.url(this.user.email);
        } else {
          return null;
        }
      },
    },
    methods: {
      async logout() {
        await this.$store.dispatch('auth/logout');
        this.$router.push('login');
      },
    },
  };
</script>
